// Toast 提示工具
export function showToast(message, type = 'success') {
  let container = document.getElementById('toast-container')
  if (!container) {
    container = document.createElement('div')
    container.id = 'toast-container'
    container.className = 'fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2 pointer-events-none'
    document.body.appendChild(container)
  }
  
  const el = document.createElement('div')
  const bgColor = type === 'success' 
    ? 'bg-green-500/20 border-green-500/50 text-green-400' 
    : 'bg-red-500/20 border-red-500/50 text-red-400'
  const icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'
  
  el.className = `pointer-events-auto flex items-center gap-3 px-6 py-3 rounded-full border backdrop-blur-md shadow-2xl transition-all duration-300 transform translate-y-[-20px] opacity-0 ${bgColor}`
  el.innerHTML = `<i class="fas ${icon}"></i> <span class="text-sm font-bold">${message}</span>`
  container.appendChild(el)
  
  requestAnimationFrame(() => {
    el.classList.remove('translate-y-[-20px]', 'opacity-0')
  })
  
  setTimeout(() => {
    el.classList.add('opacity-0', 'translate-y-[-20px]')
    setTimeout(() => el.remove(), 300)
  }, 3000)
}

export function showSuccessToast(message) {
  showToast(message, 'success')
}

export function showErrorToast(message) {
  showToast(message, 'error')
}



